/*** Update price on Product Page when quantity is changed ***/

window.addEventListener("variant:changed", function(evt) {
  window.variant_base_price = evt.detail.price;
  $('#quantity').val(1).change();
}, false);

document.addEventListener("DOMContentLoaded", function() {
  $('#quantity').change(function() {
    var prc = parseInt(window.variant_base_price) * parseInt($(this).val());
    var formatted = window.Shopify.formatMoney(prc, $('body').data('money-format'));
    $('.js-product-section .price-ui .price .money').text(formatted);
    // Update sticky price at the same time:
    $('.sticky-price .money').text(formatted);
    if (typeof updateShipping !== 'undefined') {
      updateShipping();
    }
  });
});

/*** End Update price on Product Page when quantity is changed ***/

/*** Add priority order processing to Cart ***/
document.addEventListener("DOMContentLoaded", () => {

  let priorityShippingVariantID;

  if (window.location.href.includes("organics-best-test-store")) { 
    priorityShippingVariantID = 42186647240948;
  } else {
    priorityShippingVariantID = 38054108266682;
  }


  // getCart object - function
  async function getCart() {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }
    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
  }

   // addItem to cart - function
   async function addItem(variantId, quantity) {
       const result = await fetch("/cart/add.json", {
           method: "POST",
           headers: {
               "Content-Type": "application/json",
               "Accept": "application/json"
           },
           body: JSON.stringify({
               id: variantId,
               quantity: quantity
           })
       })
   }

    // check if priorityShippingInCart
    (async() => {
      const cart = await getCart();
        console.log(cart);
            var priorityShippingInCart = false;
            for (const cartItem of cart.items) {
                if (cartItem.id == priorityShippingVariantID) {
                  console.log("priority shipping in cart");
                  priorityShippingInCart = true;
                  const priorityOrderWrapper = document.querySelector('.custom-priority-order__wrapper');
                  priorityOrderWrapper.style.display = 'none';
                }
            }
    })()   

  // Handle priority shipping checkbox
 const checkbox = document.getElementById('checkbox-priority-order');
  const button = document.querySelector('.add_to_cart.global-button.global-button--primary[name="add"]');
  
  // Listen for form submission to add priority shipping after main product
  document.addEventListener('submit', async function(event) {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    
    const checkbox = document.getElementById('checkbox-priority-order');
    if (checkbox && checkbox.checked) {
      // Let the main form submit first, then add priority shipping
      event.preventDefault();
      
      // Submit the main form first
      const formData = new FormData(form);
      const mainProductResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (mainProductResponse.ok) {
        // Now add priority shipping
        try {
          await addItem(priorityShippingVariantID, 1);
          console.log("Priority shipping added successfully");
          
          // Redirect to cart or show success
          if (window.PXUTheme && window.PXUTheme.theme_settings.cart_action === 'redirect_checkout') {
            window.location.href = '/checkout';
          } else {
            window.location.href = '/cart';
          }
        } catch (error) {
          console.error("Error adding priority shipping:", error);
          // Still redirect to cart even if priority shipping fails
          window.location.href = '/cart';
        }
      } else {
        console.error("Error adding main product:", mainProductResponse);
        // Let the form submit normally if our custom submission fails
        form.submit();
      }
    }
  });
});
/*** End Add priority order processing to Cart ***/